export const SUBSCRIPTION_PRICES = {
  standard_dollars: '260',
  standard_cents: '260.00',
  allied_dollars: '255',
  allied_cents: '255.00',
  sio2023_dollars: '195',
  sio2023_cents: '195.00'
};
